import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

// Estilos para el PDF (similar a CSS pero limitado)
const styles = StyleSheet.create({
  page: { padding: 50, fontSize: 10, fontFamily: 'Helvetica', color: '#1e293b' },
  header: { 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    marginBottom: 20, 
    borderBottom: 1, 
    borderBottomColor: '#cbd5e1', 
    paddingBottom: 10 
  },
  logoArea: { width: 150 },
  logoText: { fontSize: 18, fontWeight: 'bold', color: '#0f172a' },
  headerInfo: { textAlign: 'right' },
  title: { fontSize: 14, fontWeight: 'bold', marginBottom: 2, color: '#0f172a' },
  
  section: { marginBottom: 15 },
  sectionTitle: { 
    fontSize: 11, 
    fontWeight: 'bold', 
    backgroundColor: '#f1f5f9', 
    padding: 5, 
    marginBottom: 8, 
    textTransform: 'uppercase',
    color: '#334155'
  },
  
  grid: { flexDirection: 'row', flexWrap: 'wrap', marginBottom: 5 },
  col: { width: '50%', marginBottom: 6 },
  label: { fontSize: 8, color: '#64748b', marginBottom: 1, fontWeight: 'bold' },
  value: { fontSize: 10, color: '#1e293b' },
  
  footer: { 
    position: 'absolute', 
    bottom: 40, 
    left: 50, 
    right: 50, 
    borderTop: 1, 
    borderTopColor: '#e2e8f0', 
    paddingTop: 10 
  },
  disclaimerTitle: { fontSize: 8, fontWeight: 'bold', marginBottom: 3 },
  disclaimerText: { fontSize: 7, color: '#94a3b8', lineHeight: 1.4, textAlign: 'justify' },
  signatureArea: { flexDirection: 'row', justifyContent: 'space-around', marginTop: 40 },
  signatureLine: { borderTop: 1, borderTopColor: '#000', width: 150, textAlign: 'center', paddingTop: 5, fontSize: 8 }
});

const ReservationPDF = ({ reservation }) => {
  const date = reservation.created_at ? new Date(reservation.created_at).toLocaleDateString('es-MX') : 'N/A';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Encabezado Personalizado */}
        <View style={styles.header}>
          <View style={styles.logoArea}>
            {/* Para agregar un logo real: <Image src="/ruta/al/logo.png" /> */}
            <Text style={styles.logoText}>SENDEROS</Text>
            <Text style={{ fontSize: 8, color: '#64748b' }}>DE PROVIDENCIA</Text>
          </View>
          <View style={styles.headerInfo}>
            <Text style={styles.title}>SOLICITUD DE RESERVACIÓN</Text>
            <Text style={{ fontSize: 9 }}>Folio Interno: #{reservation.reservation_id}</Text>
            <Text style={{ fontSize: 9 }}>Fecha de Solicitud: {date}</Text>
          </View>
        </View>

        {/* Lote */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>1. Detalles de la Ubicación</Text>
          <View style={styles.grid}>
            <View style={styles.col}>
              <Text style={styles.label}>IDENTIFICADOR DEL LOTE</Text>
              <Text style={styles.value}>{reservation.id_lots}</Text>
            </View>
            <View style={styles.col}>
              <Text style={styles.label}>ESTATUS ACTUAL</Text>
              <Text style={styles.value}>{reservation.status === 'pending' ? 'Pendiente de Validación' : 'Confirmado'}</Text>
            </View>
          </View>
        </View>

        {/* Cliente */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>2. Información del Solicitante</Text>
          <View style={styles.grid}>
            <View style={{ width: '100%', marginBottom: 6 }}>
              <Text style={styles.label}>NOMBRE COMPLETO</Text>
              <Text style={styles.value}>{`${reservation.cliente?.nombre} ${reservation.cliente?.apellido_paterno} ${reservation.cliente?.apellido_materno}`}</Text>
            </View>
            <View style={styles.col}><Text style={styles.label}>TELÉFONO</Text><Text style={styles.value}>{reservation.cliente?.telefono}</Text></View>
            <View style={styles.col}><Text style={styles.label}>CORREO ELECTRÓNICO</Text><Text style={styles.value}>{reservation.cliente?.email}</Text></View>
            <View style={styles.col}><Text style={styles.label}>OCUPACIÓN</Text><Text style={styles.value}>{reservation.datos_cliente?.occupacion}</Text></View>
            <View style={styles.col}><Text style={styles.label}>NACIONALIDAD</Text><Text style={styles.value}>{reservation.datos_cliente?.nacionalidad}</Text></View>
          </View>
        </View>

        {/* Plan Financiero */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>3. Resumen de Plan Financiero</Text>
          <View style={styles.grid}>
            <View style={styles.col}><Text style={styles.label}>INVERSIÓN TOTAL</Text><Text style={styles.value}>$ {reservation.contributions?.total_contribution?.toLocaleString()}</Text></View>
            <View style={styles.col}><Text style={styles.label}>MONTO DE APARTADO</Text><Text style={styles.value}>$ {reservation.contributions?.reservation_payment?.toLocaleString()}</Text></View>
            <View style={styles.col}><Text style={styles.label}>ENGANCHE INICIAL</Text><Text style={styles.value}>$ {reservation.contributions?.initial_contribution?.toLocaleString()}</Text></View>
            <View style={styles.col}><Text style={styles.label}>PLAN DE PAGOS</Text><Text style={styles.value}>{reservation.contributions?.monthly_contribution} mensualidades de $ {reservation.contributions?.monthly_amount?.toLocaleString()}</Text></View>
          </View>
          <View style={{ marginTop: 5 }}>
            <Text style={styles.label}>CANTIDAD TOTAL EN LETRA</Text>
            <Text style={styles.value}>{reservation.contributions?.total_contribution_text || '____________________________________________________'}</Text>
          </View>
        </View>

        {/* Promotor */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>4. Asesor / Promotor</Text>
          <Text style={styles.value}>{reservation.promoter?.name || 'Venta Directa'}</Text>
        </View>

        {/* Firmas */}
        <View style={styles.signatureArea}>
          <View style={styles.signatureLine}><Text>Firma del Cliente</Text></View>
          <View style={styles.signatureLine}><Text>Asesor / Empresa</Text></View>
        </View>

        {/* Footer y Disclaimer */}
        <View style={styles.footer}>
          <Text style={styles.disclaimerTitle}>TÉRMINOS Y CONDICIONES:</Text>
          <Text style={styles.disclaimerText}>
            Esta solicitud es un documento de registro preliminar y no constituye un contrato de compraventa final. El apartado del lote queda sujeto a la validación del comprobante de pago por parte de la administración y a la disponibilidad del inmueble al momento del depósito. Los datos personales aquí recabados están protegidos conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y nuestro Aviso de Privacidad vigente.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReservationPDF;